<apm-select
  class="segment-multiselect"
  [(ngModel)]="selectedSegment"
  [bindValue]="bindValue"
  [searchable]="true"
  [clearable]="true"
  [multiple]="multiple"
  [items]="segments$ | async"
  (selectChange)="onSegmentSelectionChanged()"
  bindLabel="description"
>
  <div
    class="d-flex align-items-center position-relative h-100 px-2 fw-bold text-white"
    *apmSelectLabelTpl="let segment; let clear = clear"
    [ngStyle]="{ background: segment?.color }"
  >
    {{ segment.description }}
  </div>
  <div class="d-flex position-relative" *apmSelectOptionlTpl="let segment; let clear = clear">
    <div class="segment-block" [ngStyle]="{ background: segment?.color }"></div>
    {{ segment.description }}
  </div>
</apm-select>
